import { render } from "./Ingredients.vue?vue&type=template&id=edb3ad70&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"

import "./Ingredients.vue?vue&type=style&index=0&id=edb3ad70&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb3ad70"]])

export default __exports__